import { getModelAlias } from "@/utils/marketingModelNames";

const useModelAlias = (config, locale) => (name, type) =>
  getModelAlias(name, config, locale, type);

export default useModelAlias;
